import { Component } from 'react'
import TextInput from '~/components/OrdersPage/TextInput'
import Statuses, { statusesToFulfillment } from '~/components/OrdersPage/Statuses'
import DealerSelect from '~/components/OrdersPage/DealerSelect'
import OrderProperties from '~/components/OrdersPage/OrderProperties'
import OrderItems from '~/components/OrdersPage/OrderItems'
import Points from '~/utils/Points'
import Measurements from '~/utils/Measurements'
import styles from '~/styles/ordersPage.tabs.module.css'
import types from '~/types/ordersPage.ts'

export default class Tabs extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common', 'TEMPStatuses'],
		}
	}
	
	constructor(props) {
		super(props)
		this.state = {
			active: 1,
			currentBodyHeight: 0,
		}
		if (![ 'customerAddressCheckOnMap', 'onShowOnMap' ].includes(this.props.choosePointType)) {
			this._refreshPoint(null, 'onStart' + (!!this.props.order.onEdit ? 'OnEdit' : ''))
		}
		if (this.props.setUpdatePoints) {
			this.props.setUpdatePoints(this._refreshPoint.bind(this))
		}
	}
	
	render(): JSX.Element {
		let bodyStyle = {}
		if (this.state.currentBodyHeight) {
			bodyStyle = {
				minHeight: this.state.currentBodyHeight,
			}
		}
		let topClass = styles.top
		let itemsClass = styles.second
		const dealersObject = this.props?.order?.dealerAndChildDealers
		if (Object.keys(dealersObject || {}).length > 1) {
			topClass += ' ' + styles.smallerItems
		}
		if (this.state.active === 2) {
			itemsClass = ' ' + styles.active
			topClass += ' ' + styles.topItems
		}
		const isItemsRequired = false
		return (
			<div
				className={styles.main}
				onClick={this._onEmptyClick.bind(this)}
			>
				<div
					className={topClass}
				>
					<div
						className={styles.underline}
					/>
					<div
						className={styles.first + (this.state.active === 1 ? ' ' + styles.active : '')}
						onClick={this._onClick.bind(this, 1)}
					>
						<div
							className={styles.tabFrame}
						>
							<div
								className={styles.tabContent}
							>
								<div
									className={styles.title}
								>
									{this.props.t('Order')}
								</div>
								<div
									className={styles.orderNumber}
								>
									{this._getOrderNumberFrame()}
								</div>
								<div
									className={styles.statusesSelect}
								>
									{this._getOrderStatusesSelectFrame()}
								</div>
								<div
									className={styles.dealerSelect}
								>
									{this._getDealerSelectFrame()}
								</div>
							</div>
						</div>
						<div
							className={styles.underlineBlocker}
						/>
					</div>
					<div
						className={itemsClass}
						style={this._getItemsStyle()}
						onClick={this._onClick.bind(this, 2)}
					>
						<div
							className={styles.tabFrame}
						>
							<div
								className={styles.tabContent}
							>
								<div
									className={styles.title}
								>
									{this.props.t('Items')}
								</div>
								<div
									className={styles.required + (isItemsRequired ? '' : ' ' + styles.hidden)}
								>
									{this.props.t('Required')}
								</div>
							</div>
						</div>
						<div
							className={styles.underlineBlocker}
						/>
					</div>
				</div>
				<div
					className={styles.body + (this.state.active === 1 ? ' ' + styles.unsetOverflow: '')}
					style={bodyStyle}
				>
					{this._getBody()}
				</div>
			</div>
		)
	}

	componentDidMount(): void {
		this._setCurrentBodyHeight()
	}
	
	componentDidUpdate(prevProps, prevState): void {
		this._setCurrentBodyHeight()
	}

	private _setCurrentBodyHeight(): void {
		if (this._onResizeST) {
			clearTimeout(this._onResizeST)
		}
		this._onResizeST = setTimeout(() => {
			const wrapperDiv = document?.body?.querySelector('div[class^="ordersPage_tabs_body"]')
			if (wrapperDiv) {
				const rect = wrapperDiv.getBoundingClientRect()
				if (rect?.height > this.state.currentBodyHeight) {
					this.setState({ currentBodyHeight: rect?.height })
				}
			}
		}, 200)
	}
	
	private _onClick(tabNumber): void {
		if (this.props?.order?.dealerId) {
			this.setState({ active: tabNumber })
		}
	}

	private _getLabeledFrame(label, component): JSX.Element {
		return (
			<div
				className={styles.labeledFrame}
			>
				<label>
					{this.props.t(label)}
				</label>
				{component}
			</div>
		)
	}
	
	private _getOrderNumberFrame(): JSX.Element {
		const component = (
			<TextInput
				value={this.props?.order?.orderNumber || ''}
				maxlength="32"
				placeholder={this.props.t('in_id_placeholder')}
				disabled={this.props?.order?.onEdit}
				onChange={this.props.editTheOrder.bind(this, 'orderNumber')}
			/>
		)
		return this._getLabeledFrame('Order Number', component)
	}
	
	private _getOrderStatusesSelectFrame(): JSX.Element {
		const statusAsIs = this.props.t('Current status') + ': ' + this.props.t(this.props?.order?.status)
		let currentFulfillmentStatus = this.props?.order?.fulfillmentStatus || false
		if (this.props?.order?.onEdit) {
			currentFulfillmentStatus = statusAsIs
		}
		const component = (
			<Statuses
				fulfillmentStatus={currentFulfillmentStatus}
				currentStatus={this.props?.order?.status || null}
				cancelAble={this.props?.order?.onEdit ? true : false}
				setFulfillmentStatus={'setFulfillmentStatus'}
				onChange={this.props.editTheOrder}
				order={this.props.order}
				t={this.props.t}
			/>
		)
		return this._getLabeledFrame('Order Status', component)
	}

	private _getDealerSelectFrame(): JSX.Element {
		const dealersObject = this.props.order?.dealerAndChildDealers
		const isMultipleShippers = (Object.keys(dealersObject || {}).length > 1)
		const isEditMode = (this.props.order?.onEdit && Object.keys(dealersObject || {}).length === 1)
		if (isMultipleShippers || isEditMode) {
			const component = (
				<DealerSelect
					dealerAndChildDealers={this.props.order.dealerAndChildDealers}
					order={this.props.order}
					onChange={this.props.editTheOrder}
					onShipperChanged={this._onShipperChanged.bind(this)}
					chargeableWeightUpdater={this._chargeableWeightUpdater}
					refreshPoint={this._refreshPoint.bind(this)}
					setDealerSelectToBeClosed={this._setDealerSelectToBeClosed.bind(this)}
					isDisabled={isEditMode}
					t={this.props.t}
				/>
			)
			return this._getLabeledFrame('Dealer', component)
		} else {
			return null
		}
	}
	
	private _getBody(): JSX.Element {
		if (this.props?.order?.dealerId) {
			if (this.state.active === 1) {
				return (
					<OrderProperties
						order={this.props.order}
						editTheOrder={this.props.editTheOrder}
						onWarningChange={this.props.onWarningChange}
						showMap={this.props.showMap}
						setChargeableWeightUpdater={this._setChargeableWeightUpdater.bind(this)}
						chargeableWeightUpdater={this._chargeableWeightUpdater}
						setShipperUpdater={this._setShipperUpdater.bind(this)}
						t={this.props.t}
						currentDealer={this.props.currentDealer}
						isRu={this.props.isRu}
					/>
				)
			} else if (this.state.active === 2) {
				return (
					<div
						className={styles.orderItems}
					>
						<OrderItems
							order={this.props.order}
							onNewOrder={this._onOrderItemsChange.bind(this)}
							authDealerId={this.props.authDealerId}
							isAbleForEditing={true}
							isEditing={true}
							hideCloneButton={true}
							hideOkButton={true}
							hideCloseButton={true}
							hideCaption={true}
							frameQuerySelector='div[class^="ordersPage_tabs_body"]'
							locale={this.props.locale}
							t={this.props.t}
						/>
					</div>
				)
			} else {
				return null
			}
		} else {
			let content: Array<JSX.Element> | JSX.Element | string = []
			content.push(this._getLoading(0))
			content.push(this._getLoading(1))
			content.push(this._getLoading(2))
			return (
				<div
					className={styles.waiting}
				>
					{content}
				</div>
			)
		}
	}

	private _getLoading(i): JSX.Element | null {
		let divs: Array<JSX.Element> = []
		for (let j = 0; j < 9; j++) {
			divs.push(( <div key={j}/> ))
		}
		return (
			<div
				key={i}
				className={styles.loadingGrid}
			>
				{divs}
			</div>
		)
	}
	
	private _onOrderItemsChange(order, reRequestPointPrice) {
		this.props.editTheOrder('onOrderItemsChange', order)
		if (reRequestPointPrice) {
			this._refreshPoint(order)
		}
	}
	
	private _refreshPoint(order, choosePointType?: string) {
		if (this._onPointsST) {
			clearTimeout(this._onPointsST)
		}
		this._onPointsST = setTimeout(async () => {
			if (!order) {
				order = this.props.order
			}
			if (!choosePointType) {
				choosePointType = 'orderItemsAreChanged'
			}
			if (this.props.order?.dealer_weight_mu) {
				const points = new Points({
					order: this.props.order,
					choosePointType,
					isRu: this.props.isRu,
				})
				let newData
				const isThreePoints = (choosePointType === 'orderItemsAreChanged' && order?.points?.length === 3)
				const hasChildDealer = (choosePointType === 'orderItemsAreChanged' && this.props.order.shipperId)
				if (isThreePoints || hasChildDealer) {
					const address = order.manuallyEnteredCustomerAddress
					newData = await points.getNearestPoints(address, order.selectedPointId)
				} else {
					newData = await points.getPointByPointId(order.in_point || order.in_point_uuid)
				}
				if (newData) {
					const dimensionalMU = this.props.order.dealer_dimensions_mu
					const weightMU = this.props.order.dealer_weight_mu
					const measurements = new Measurements(dimensionalMU, weightMU)
					const { muLength, muWidth, muHeight, muWeight } = measurements.getByOrder(this.props.order)
					const sameTotal = (newData.totalPrice === order.in_total)
					const sameLength = (newData.muLength === muLength)
					const sameWidth = (newData.muWidth === muWidth)
					const sameHeight = (newData.muHeight === muHeight)
					const sameWeight = (newData.muWeight === muWeight)
					if (sameTotal && sameLength && sameWidth && sameHeight && sameWeight) {
						const isPreserved = (choosePointType === 'onStartOnEdit' && newData.in_point === order.in_point)
						if (!isPreserved) {
							this.props?.editTheOrder(newData)
						}
					}
				}
			}
		}, 200)
	}
	
	private _getItemsStyle() {
		let orderItemTitleMaxLength = 0
		const emWidth = Math.round((orderItemTitleMaxLength - 10) / 1.5)
		if (emWidth > 20) {
			const style = { width: emWidth + 'em' }
			return style
		} else {
			return null
		}
	}

	private _setChargeableWeightUpdater(callback) {
		if (typeof callback === 'function') {
			this._chargeableWeightUpdater = callback.bind(this)
			// this.props.setPackageFind(callback)
		}
	}

	private _onEmptyClick(event) {
		const target = event.target
		let isNotTarget = true
		if (this._onEmptyClickCssQueries) {
			this._onEmptyClickCssQueries.some(cssQuery => {
				if (target.closest(cssQuery)) {
					isNotTarget = false
					return true
				}
			})
		}
		if (isNotTarget) {
			if (typeof this._dealerSelectToBeClosed === 'function') {
				this._dealerSelectToBeClosed()
			}
		}
	}

	private _setDealerSelectToBeClosed(callback, cssQueries) {
		if (typeof callback === 'function') {
			this._dealerSelectToBeClosed = callback
			this._onEmptyClickCssQueries = cssQueries
		}
	}

	private _setShipperUpdater(callback) {
		if (typeof callback === 'function') {
			this._shipperUpdater = callback
		}	
	}

	private _onShipperChanged(changes, isByDefault) {
		if (typeof this._shipperUpdater === 'function') {
			this._shipperUpdater(changes, isByDefault)
		}
	}


}